function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/* global document */
import axios from 'axios';
import BaseStorage from '../base-storage';
import { NOT_FOUND, SERVER_ERROR } from '../utils/constants';

function getCookieValue(name) {
  if (typeof document === 'undefined') {
    return '';
  } else {
    return (document.cookie.match(name + "=([^;]*)") || ['']).pop();
  }
}

function getUserId() {
  var wixClient = getCookieValue('wixClient').split('|');
  return wixClient[6] || getCookieValue('_wixCIDX');
}

var WixStorageStrategy = /*#__PURE__*/function (_BaseStorage) {
  _inheritsLoose(WixStorageStrategy, _BaseStorage);

  var _super = _createSuper(WixStorageStrategy);

  function WixStorageStrategy() {
    return _BaseStorage.apply(this, arguments) || this;
  }

  var _proto = WixStorageStrategy.prototype;

  _proto.extendScope = function extendScope(scope) {
    scope = typeof scope === 'string' ? {
      siteId: scope
    } : scope;
    return Object.assign({
      userId: getUserId()
    }, scope);
  };

  _proto.setItem = function setItem(key, value, options) {
    var payload = {
      nameSpace: options.namespace,
      key: key,
      blob: value
    };

    if (options.scope && options.scope.siteId) {
      payload.siteId = options.scope.siteId;
    }

    if (options.expiration) {
      payload.TTLInDays = Math.ceil(options.expiration / (60 * 60 * 24));
    }

    return axios.post('/_api/wix-user-preferences-webapp/set', payload).then(function () {
      return undefined;
    })["catch"](function () {
      throw SERVER_ERROR;
    });
  };

  _proto.removeItem = function removeItem(key, options) {
    var payload = {
      nameSpace: options.namespace,
      key: key
    };

    if (options.scope && options.scope.siteId) {
      payload.siteId = options.scope.siteId;
    }

    return axios.post('/_api/wix-user-preferences-webapp/delete', payload).then(function () {
      return undefined;
    })["catch"](function () {
      throw SERVER_ERROR;
    });
  };

  _proto.getItem = function getItem(key, options) {
    var siteId = options.scope && options.scope.siteId;
    var path = siteId ? 'getVolatilePrefForSite' : 'getVolatilePrefForKey';
    var url = ['/_api/wix-user-preferences-webapp', path, options.namespace, siteId, key].filter(function (x) {
      return x;
    }).join('/');
    return axios.get(url).then(function (res) {
      return res.data[key];
    })["catch"](function (err) {
      throw err.response.status === 404 ? NOT_FOUND : SERVER_ERROR;
    });
  };

  _proto.getAllItems = function getAllItems(options) {
    var siteId = options.scope && options.scope.siteId;
    var path = siteId ? 'getVolatilePrefsForSite' : 'getVolatilePrefs';
    var url = ['/_api/wix-user-preferences-webapp', path, options.namespace, siteId].filter(function (x) {
      return x;
    }).join('/');
    return axios.get(url).then(function (res) {
      return res.data;
    })["catch"](function () {
      throw SERVER_ERROR;
    });
  };

  return WixStorageStrategy;
}(BaseStorage);

export { WixStorageStrategy as default };